import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Avatar, Spin } from "antd";
import Styles from "./NewEditorStyles.module.css";
// import QuestionBox from "./QuestionBox";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import DeclinedQuestions from "./DeclinedQuestions";
import NewOtherExpertAnswers from "./NewOtherExpertAnswers";
import ExpertSearchBar from "./ExpertSearchBar";
import ExpertSearch from "./ExpertSearch";



const onSelectedTabStyles = {
	textAlign: "center",
	borderBottom: "2px solid",
	borderImage: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%) 1",
	paddingBlock: "15px",
	fontSize: "22px",
	lineHeight: "24px",
	cursor: "pointer",
	fontWeight: "400",
	background: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
	backgroundClip: "text",
	WebkitTextFillColor: "transparent",
	MozTextFillColor: "transparent",
	msTextFillColor: "transparent",
	OTextFillColor: "transparent",
	width: "10%",
	marginLeft: "10px",
};
const onSelectedTabStyles1 = {
	textAlign: "center",
	borderBottom: "2px solid",
	borderImage: "linear-gradient(90.39deg,rgb(237, 238, 240) 0.34%,rgb(237, 238, 240) 99.7%) 1",
	paddingBlock: "15px",
	fontSize: "22px",
	lineHeight: "24px",
	cursor: "pointer",
	fontWeight: "400",
	// background: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
	backgroundClip: "text",
	WebkitTextFillColor: "transparent",
	MozTextFillColor: "transparent",
	msTextFillColor: "transparent",
	OTextFillColor: "transparent",
	width: "90%",
	// marginLeft: "10px",
};
export default function TabsSaved() {
	const pageState = useSelector((state) => state.favouriteQuestions);
	const sharedByMeState = useSelector((state) => state.sharedBy);
	const sharedWithMeState = useSelector((state) => state.sharedWith)
	const editorData = useSelector(state => state.editor);
	const [isTabChanged, setIsTabChanged] = React.useState(false)
	const dispatch = useDispatch()
	const { updateFavouriteSearchedQuery, updateSharedBySearchedQuery, updateSharedWithSearchedQuery } = bindActionCreators(Actions, dispatch)
	const onClickRegen = (val) => {
		setVal(val);
	}


	const editorState = useSelector(state => state.editor);

	const [val, setVal] = useState(3);

	// console.log("editorState", editorState)



	const spinner = !editorState.declineIsLoading && editorState.ratingBool === true;
	const anotherSpinner = editorData.anotherExpertAnswer.answers !== undefined && !editorData.ratingBool;
	// console.log("spin",!anotherSpinner)
	return (
		<>
			<div className="mt-4 mb-5">
				<div
					style={{
						display: "flex",
						width: "100%",
						justifyContent: "space-evenly",
						// marginBottom: "20px",
						// gap: '10px'
					}}
				>
					<div
						className={val === 1 ? Styles.onSelectedtab : Styles.ohHovertab}
						onClick={() => onClickRegen(1)}
						style={{
							flex: 1, // Equal width for all tabs
							display: "flex",
							justifyContent: "center", // Center content
							alignItems: "center",
							cursor: "pointer",
							padding: "10px 0",
						}}
					>
						Seeker Searches&nbsp;
						<Avatar className={Styles.numberAvatar}>
							{editorState.declineIsLoading ? "0" : editorState.declinedData?.length}
						</Avatar>
					</div>

					<div
						className={val === 2 ? Styles.onSelectedtab : Styles.ohHovertab}
						onClick={() => onClickRegen(2)}
						style={{
							flex: 1,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							cursor: "pointer",
							padding: "10px 0",
						}}
					>
						Answered by others&nbsp;
						<Avatar className={Styles.numberAvatar}>
							{editorData?.anotherExpertAnswer?.answers?.length ?? "0"}
						</Avatar>
					</div>

					<div
						className={val === 3 ? Styles.onSelectedtab : Styles.ohHovertab}
						onClick={() => onClickRegen(3)}
						style={{
							flex: 1,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							cursor: "pointer",
							padding: "10px 0",
						}}
					>
						Search&nbsp;
					</div>
				</div>

				<div>
					{val === 1 &&
						<DeclinedQuestions />
					}
					{/* {val === 1 && pageState.isLoading === false && <FavouriteTabbedComponent data={pageState.data} tab={val} />} */}

					{
						val === 2 && !editorState.ratingBool &&
						<NewOtherExpertAnswers />
					}
					{
						val === 3 && <ExpertSearch />
					}
				</div>





				{/* {noDataAvailable(pageState, sharedByMeState, sharedWithMeState)} */}
			</div>
		</>
	);
}